/**
 * Interruttore del tema (vedi lib/theme.tsx).
 *
 * Un bottone solo, non un segmentato a tre: 'auto' e' lo stato di partenza e
 * si lascia, non si sceglie. Al primo clic il tema diventa esplicito.
 * L'icona mostra *dove si va*, non dove si e': e' la convenzione diffusa e
 * l'etichetta accessibile la esplicita comunque.
 */
import { useTheme } from '../lib/theme.jsx';
import './ThemeToggle.css';

export function ThemeToggle({ tone = 'side' }: { tone?: 'side' | 'bare' }) {
  const { theme, toggle } = useTheme();
  const toDark = theme === 'light';
  const label = toDark ? 'Passa al tema scuro' : 'Passa al tema chiaro';

  return (
    <button
      type="button"
      className={`themetgl themetgl--${tone}`}
      onClick={toggle}
      title={label}
      aria-label={label}
      aria-pressed={!toDark}
    >
      <span className="material-symbols-outlined" aria-hidden="true">
        {toDark ? 'dark_mode' : 'light_mode'}
      </span>
      <span className="themetgl__text">{toDark ? 'Scuro' : 'Chiaro'}</span>
    </button>
  );
}
